(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('.jab-col');
  if(!root) return;

  // Hero: auto-rotate colorway images
  var heroImgs = root.querySelectorAll('.jab-hero__img');
  if(heroImgs.length > 1 && !reduce){
    var hi = 0;
    setInterval(function(){
      heroImgs[hi].classList.remove('is-active');
      hi = (hi + 1) % heroImgs.length;
      heroImgs[hi].classList.add('is-active');
    }, 2800);
  }

  // Grid: Summer / All toggle (fixed order, no shuffle)
  var grid = root.querySelector('.jab-grid');
  var tabs = root.querySelectorAll('.jab-toggle__btn');
  if(grid){
    tabs.forEach(function(btn){
      btn.addEventListener('click', function(){
        grid.setAttribute('data-view', btn.dataset.view);
        tabs.forEach(function(b){ var on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
      });
    });
  }
})();
